import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAllExportsXmpMetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAllExportsXmpMetadataQuery = { __typename?: 'Query', getAllExportsXmpMetadata: Array<{ __typename?: 'SequenceExportsXMPMetadata', exportedAt: number, assetId: string, versionId?: string | null, shareId?: string | null, projectId: string, accountId: string, sequenceId?: string | null, sequenceName?: string | null, sequenceIn?: number | null, sequenceOut?: number | null } | { __typename?: 'V3PanelExportsXMPMetadata' } | { __typename?: 'V4CommentsPanelExportsXMPMetadata', exportedAt: number, shareId?: string | null, sequenceId?: string | null } | null> };


export const GetAllExportsXmpMetadata = /*#__PURE__*/ gql`
    query GetAllExportsXmpMetadata {
  getAllExportsXmpMetadata {
    ... on SequenceExportsXMPMetadata {
      exportedAt
      assetId
      versionId
      shareId
      projectId
      accountId
      sequenceId
      sequenceName
      sequenceIn
      sequenceOut
    }
    ... on V4CommentsPanelExportsXMPMetadata {
      exportedAt
      shareId
      sequenceId
    }
  }
}
    ` as unknown as DocumentNode<GetAllExportsXmpMetadataQuery, GetAllExportsXmpMetadataQueryVariables>;

          

          export const useGetAllExportsXmpMetadataQuery = (options?:QueryHookOptions<GetAllExportsXmpMetadataQuery, GetAllExportsXmpMetadataQueryVariables>) => useQuery(GetAllExportsXmpMetadata, options);

          

          export type GetAllExportsXmpMetadataQueryOptions = QueryHookOptions<GetAllExportsXmpMetadataQuery, GetAllExportsXmpMetadataQueryVariables>;

          

          export const useGetAllExportsXmpMetadataLazyQuery = (options?:LazyQueryHookOptions<GetAllExportsXmpMetadataQuery, GetAllExportsXmpMetadataQueryVariables>) => useLazyQuery(GetAllExportsXmpMetadata, options);

          

          export type GetAllExportsXmpMetadataQueryResult = ReturnType<typeof useGetAllExportsXmpMetadataQuery>;

          
